import React, { Component } from 'react'
import Rowbox from '../../Common/Rowbox'
import { DECORATION_SHOP_INFO, EDIT_STORE_PATH } from '@constant'
import { hashHistory } from 'react-router'
import { inject, observer } from 'mobx-react'
import PhoneHeader from '../../Common/PhoneHeader'
import style from './style.module.less'
import { Flex } from 'hljd'
import { POSITION_MAP } from '@components/LocalMerchant/SiDa/constant'
import { Rating } from 'hljd'
import { getMerchantInfo } from '@util'
import { SHOP_INFO_STATUS_MAP } from '@components/LocalMerchant/Decoration/constant'
import { Modal } from 'hljd'

@inject('decorationStore')
@observer
export default class extends Component {
  state = {
    showMore: false
  }

  getStatus = () => {
    const { status } = getMerchantInfo()
    return SHOP_INFO_STATUS_MAP[String(status)]
  }

  handleClick = () => {
    if (this.props.decorationStore.mode == 'preview') {
      return
    }
    const { examine, is_opened_trade } = getMerchantInfo()
    // 店铺审核未通过或未交店铺服务费的不能编辑
    if (examine != 1 || !is_opened_trade) {
      return Modal.info({
        title: '店铺处于入驻审核阶段，不可编辑店铺信息'
      })
    }
    hashHistory.push(EDIT_STORE_PATH)
  }

  render() {
    const {
      decorationStore: { promiseData, newThemeConfig }
    } = this.props
    let {
      des,
      working_seniority,
      position,
      logo_path,
      name,
      merchant_comment = {}
    } = promiseData
    const { score, total_good_count } = merchant_comment
    des = des || ''
    const twoLineTextCount = 38
    const shouldHide = des.length > twoLineTextCount
    const { showMore } = this.state
    return (
      <Rowbox
        type={DECORATION_SHOP_INFO}
        store={this.props.decorationStore}
        style={{
          padding: 0,
          height: 'auto',
          flexDirection: 'column'
        }}
        vCenter={false}
        onClick={this.handleClick}
        status={this.getStatus()}
      >
        <PhoneHeader />

        <div
          className={style.bg}
          style={{
            backgroundImage: `url(${logo_path})`
          }}
        />

        <div
          className={style.member}
          style={{ backgroundColor: newThemeConfig['shopInfoBoxBg'] }}
        >
          <Flex
            style={{
              paddingBottom: 15,
              borderBottom: `1px solid ${newThemeConfig['splitLine']}`
            }}
          >
            <img src={logo_path} className={style.logo} />

            <Flex d="v" hc>
              <div>
                <span className={style.title}>{name}</span>
                <img src="" />
              </div>
              <div>
                <span>{position ? `${POSITION_MAP[position]}` : ''}</span>
                <span className={style.line}>|</span>
                <span>从业{working_seniority}年</span>
              </div>

              <Flex vc>
                <Rating
                  value={Number(score)}
                  defaultStar={newThemeConfig['defaultStar']}
                  coverStar={newThemeConfig['coverStar']}
                  size={11}
                />

                <span style={{ margin: '0 2px 0 5px' }}>
                  {total_good_count > 999 ? '999+' : total_good_count}
                </span>
                <span>好评数</span>
              </Flex>
            </Flex>
          </Flex>

          <Flex style={{ marginTop: 15 }}>
            <span
              style={{ flexShrink: 0, color: newThemeConfig['moduleTitle'] }}
            >
              简介：
            </span>
            <div>
              <div>
                {shouldHide && !showMore ? des.slice(0, twoLineTextCount) : des}
              </div>

              {shouldHide && (
                <div
                  onClick={() => {
                    this.setState({ showMore: !showMore })
                  }}
                  style={{ color: newThemeConfig['editText'] }}
                >
                  {showMore ? '收起' : '查看更多'}
                </div>
              )}
            </div>
          </Flex>
        </div>
      </Rowbox>
    )
  }
}
